import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { generateTestCard, CARD_BRANDS } from './utils/testCardGenerator'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const TestCardGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de Cartão de Teste (Luhn)  jarder.dev',
    description:
      'Gere números de cartão fictícios que passam na validação Luhn, ' +
      'para testar integrações de pagamento em ambiente de ' +
      'desenvolvimento. Não são cartões reais.',
  })

  const [brandKey, setBrandKey] = useState('visa')
  const [card, setCard] = useState(() => generateTestCard('visa'))
  const [copied, setCopied] = useState(false)

  const generate = (nextBrand = brandKey) => {
    setCard(generateTestCard(nextBrand))
    trackEvent('tool_generate', { tool: 'test_card', brand: nextBrand })
  }

  const copy = () => {
    navigator.clipboard.writeText(card.number).then(() => {
      setCopied(true)
      trackEvent('tool_copy', { tool: 'test_card' })
      setTimeout(() => setCopied(false), 1500)
    })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de Cartão de Teste</h1>
      <p className="tool-disclaimer">
        Números fictícios que passam na validação Luhn (o mesmo algoritmo
        de checksum usado pelas bandeiras), <strong>apenas para testar
          formulários e integrações de pagamento em desenvolvimento</strong>.
        Não são cartões reais e não funcionam em nenhuma cobrança de
        verdade.
      </p>

      <div className="tool-field">
        <label htmlFor="brand">Bandeira</label>
        <select
          id="brand"
          value={brandKey}
          onChange={(e) => {
            setBrandKey(e.target.value)
            generate(e.target.value)
          }}
        >
          {CARD_BRANDS.map((b) => (
            <option key={b.key} value={b.key}>
              {b.label}
            </option>
          ))}
        </select>
      </div>

      <div className="tool-result-card">
        <span className="tool-result-label">{card.brand}</span>
        <span className="tool-result-value">{card.formatted}</span>
        <div className="tool-result-actions">
          <button
            type="button"
            className="tool-button tool-button-secondary"
            onClick={copy}
          >
            Copiar número
          </button>
          <button
            type="button"
            className="tool-button"
            onClick={() => generate()}
          >
            Gerar novo
          </button>
        </div>
        {copied && <span className="tool-copied">Copiado!</span>}
      </div>

      <div className="tool-row">
        <div className="tool-field">
          <label>Validade</label>
          <span className="tool-result-value">{card.expiry}</span>
        </div>
        <div className="tool-field">
          <label>CVV</label>
          <span className="tool-result-value">{card.cvv}</span>
        </div>
      </div>

      <div className="tool-info-section">
        <h2>O que é o algoritmo de Luhn</h2>
        <p>
          É a fórmula de checksum usada pelas bandeiras de cartão para
          detectar erros de digitação: o último dígito do número é
          calculado a partir dos anteriores, então digitar um número
          qualquer quase sempre falha nessa verificação. Os números aqui
          são gerados para passar nesse checksum e simular um cartão
          válido, mas não estão associados a nenhuma conta bancária real
          e não processam nenhum pagamento de verdade.
        </p>
      </div>
    </div>
  )
}

export default TestCardGenerator
